import React from "react";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./JobTemplateFull.scss";

const JobTemplateFull = ({ jobTemplate, setIsUpdate, setIsDelete }) => {
  // Définition du titre de la page
  UseTitle("Métier " + (jobTemplate?.name || ""));

  const { isAdmin } = useAuth();

  return (
    <>
      <div className="job-template-full">
        <h1>{jobTemplate.name}</h1>

        {/* Informations */}
        <div className="infos">
          <h3>Informations</h3>
          <p className="element">
            <em>Description : {jobTemplate.description || "-"}</em>
          </p>
          <p className="element">
            Région de départ : {jobTemplate.is_natal ? "Oui" : "Non"}
          </p>
        </div>

        {/* Compétences */}
        {jobTemplate.skills_templates.length > 0 && (
          <div className="skills">
            <h3>Compétences ({jobTemplate.skills_templates.length})</h3>
            <ul className="element">
              {jobTemplate.skills_templates.map((skillTemplate, index) => (
                <li key={index} className="skill">
                  {skillTemplate.name}{" "}
                  <small>
                    (
                    {skillTemplate.attributes
                      .map((attribute) => attribute.full_name)
                      .join(", ")}
                    )
                  </small>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Sorts */}
        {jobTemplate.spells_templates.length > 0 && (
          <div className="spells">
            <h3>Sorts ({jobTemplate.spells_templates.length})</h3>
            <ul className="element">
              {jobTemplate.spells_templates.map((spellTemplate, index) => (
                <li key={index} className="spell">
                  {spellTemplate.name}{" "}
                  <small>
                    (
                    {spellTemplate.attributes
                      .map((attribute) => attribute.full_name)
                      .join(", ")}
                    )
                  </small>
                </li>
              ))}
            </ul>
          </div>
        )}

        {isAdmin && (
          <div className="buttons">
            <button className="bt" onClick={() => setIsUpdate(true)}>
              Modifier
            </button>
            <button className="bt" onClick={() => setIsDelete(true)}>
              Supprimer
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default JobTemplateFull;
